module.exports = __webpack_public_path__ + "static/media/CBO-Community_Based_Network_Challenges_02-02-2024-removebg-preview.c7061025.png";